<template>
   <v-app id="inspire">
      <v-main>
         <v-container fluid fill-height>
            <v-layout align-center justify-center>
               <v-flex xs12 sm8 md4>
                  <v-card class="elevation-12">
                     <v-toolbar dark color="indigo">
                        <v-toolbar-title>TestVirtual</v-toolbar-title>
                     </v-toolbar>
                     <v-card-text>
                        <v-form>
                           <v-text-field
                              prepend-icon="mdi-account"
                              name="login"
                              label="Usuario"
                              type="text"
                              v-model="username"
                              :rules="[v => !!v || 'El usuario es requerido']"
                              required
                           ></v-text-field>
                           <v-text-field v-on:keyup.enter="authenticate"
                              id="password"
                              prepend-icon="mdi-lock"
                              name="password"
                              label="Contraseña"
                              type="password"
                              v-model="password"
                              :rules="[v => !!v || 'La contraseña es requerido']"
                              required
                           ></v-text-field>
                        </v-form>
                        <v-alert v-if="error" dense outlined type="error">
                          Usuario y/o contraseña incorrectos.
                        </v-alert>
                     </v-card-text>
                     <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn @click.prevent="authenticate" color="primary">Ingresar</v-btn>
                     </v-card-actions>
                  </v-card>
               </v-flex>
            </v-layout>
         </v-container>
      </v-main>
   </v-app>
</template>

<script>
import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";
import VueAxios from "vue-axios";

Vue.use(Vuex);
Vue.use(VueAxios, axios);

Vue.axios.defaults.baseURL = process.env.VUE_APP_HOST;

export default {
  data() {
    return {
      error: false,
      username: "",
      password: "",
    };
  },
   methods: {
      authenticate() {

         this.error = false;

         const payload = {
            username: this.username,
            password: this.password,
         };

         Vue.axios.post("auth/obtain_token/", payload)
            .then((response) => {

               if (response.status == 200) {

                  this.$store.commit("updateToken", response.data.token);

                  Vue.axios.get("currentuser/")
                     .then((response) => {

                        this.$store.commit(
                           "setAuthUser", 
                           {authUser: response.data, isAuthenticated: true}
                        );

                        this.$router.push('/')

                     })
                     .catch((error) => {
                        throw new Error(`API ${error}`);
                     });

               }
               else {
                  this.error = true;
               }
               
            })
            .catch((error) => {
               this.error = true;
               throw new Error(`API ${error}`);
            });
      },
   },
};
</script>

<style lang="css">
</style>